import { useTranslation } from 'react-i18next'

import AlertNotification from '@/common/components/AlertNotification/AlertNotification'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import { getAlertActions, getAlertTitle, getDisabledActionExtraInfo } from './helpers'

const TransactionAlert = ({
  alert,
  onClickMissingCustomsData,
  onClickIssueRefund,
  onClickCreateExchangeOrder,
  onClickMarkAsResolved,
  onClickContactCustomer,
  onClickReviewAdditionalReturnedProducts,
  onClickEditAddressAndRetryLabel,
  onClickRetryLabel,
  isRetryLabelHidden,
  isRetryLabelDisabled,
  retryLabelDisabledReason,
  storeId,
}) => {
  const { t } = useTranslation()
  const { hasPermission } = useUserPermissions()

  const title = getAlertTitle(alert, t)

  const actions = getAlertActions({
    alert,
    t,
    onClickMissingCustomsData,
    onClickIssueRefund,
    onClickCreateExchangeOrder,
    onClickMarkAsResolved,
    onClickContactCustomer,
    onClickReviewAdditionalReturnedProducts,
    onClickEditAddressAndRetryLabel,
    onClickRetryLabel,
    isRetryLabelHidden,
    isRetryLabelDisabled,
    hasPermission,
    storeId,
  })

  const extraInfo = getDisabledActionExtraInfo(actions, retryLabelDisabledReason)

  if (!title) return null

  return <AlertNotification title={title} createdAt={alert?.created_at} actions={actions} extraInfo={extraInfo} />
}

export default TransactionAlert
